import numeral from 'numeral';
import React from 'react';

import styles from './ReviewFund.scss';

import If from '../../Shared/If/If';
import { PRODUCT_TYPE_LABEL_MAP } from '../../../settings/settings';
import {
  isProductType529,
  isRetirementFund,
} from '../../../utils/funds/funds-utility';
import {
  replaceSpecialCharacterWith,
  replaceSpecialCharacterWithSpace,
} from '../../../utils/shoppingCart/shopping-cart-utility';
import { isAppBuy, TRADE_DATE_TOOLTIP } from 'src/utils/transactions-util';
import ToolTip from '../../Shared/ToolTip/ToolTip';
import { TOOLTIP_POSITION_BOTTOM } from '../../../utils/dom-utils';
import { formatUnixDate } from '../../../utils/dates/date-utility';

function ReviewFund({ fund, eligibleTradeDates = {} }) {
  const displayClassification = replaceSpecialCharacterWith(
    fund.displayClassification,
    '-'
  ).toUpperCase();
  const agreementType = replaceSpecialCharacterWithSpace(
    fund.agreementType
  ).toUpperCase();

  const displayPlanType = isProductType529(fund.productType)
    ? PRODUCT_TYPE_LABEL_MAP[fund.productType]
    : `${displayClassification} / ${agreementType}`;

  const agreementStyleName = fund.newFund
    ? 'review-fund-new-agreement-number'
    : 'review-fund-user';

  return (
    <div className="review-fund-selectedFunds row e2e-review-fund">
      <div className="review-fund-selectedFunds-inner">
        <div className="col-sm-6 col-md-6 col-xs-12">
          <div className="review-fund-group e2e-review-fund-plan-type">
            {displayPlanType}
          </div>
          <div className="review-fund-fundName">{fund.fundName}</div>
          <div className="review-fund-ticker">
            {!isProductType529(fund.productType) && !isAppBuy() && fund.ticker}
          </div>
          <div className="review-fund-fund-details">
            <span
              className={`blocked_data text-nowrap ${agreementStyleName} roth-conversion-review_new-fund`}
            >
              {fund.newFund ? 'Just Added' : fund.agreementNumber}
            </span>
            <span className="review-fund-agreement-number-spacer">&#8901;</span>
            <span
              className="blocked_data review-fund-user"
              title={fund.formattedEntityNames}
            >
              {fund.formattedEntityNames}
            </span>
          </div>
          <div className="review-trade-place eligible-purchase-trade-date-fund">
            Projected Trade Date:{' '}
            <span className="review-trade-place-date">
              {fund.newFund
                ? formatUnixDate(eligibleTradeDates[fund.trpCode])
                : formatUnixDate(eligibleTradeDates[fund.agreementID])}
            </span>
            {!isAppBuy() && (
              <ToolTip
                message={TRADE_DATE_TOOLTIP}
                placement={TOOLTIP_POSITION_BOTTOM}
              />
            )}
          </div>
          <If test={fund.moneyMarketReformMessage}>
            <div
              className={styles['mmr-event-message']}
              dangerouslySetInnerHTML={{
                __html: fund.moneyMarketReformMessage,
              }}
            />
          </If>
        </div>
      </div>
      <div className="col-sm-3 col-md-3 col-xs-12">
        <div className="review-fund-contribution-year">
          {isRetirementFund(fund) && (
            <div>
              Contribution Year:{' '}
              <span className="review-fund-contribution-year-value">
                {fund.contributionYear}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="col-sm-3 col-md-3 col-xs-12">
        <div className="review-fund-fund">
          <div>{numeral(fund.amount || 0).format('$0,0.00')}</div>
        </div>
      </div>
    </div>
  );
}

export default ReviewFund;
